import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLeft = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 12,
	height: 21,
	viewBox: "0 0 12 21",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11.5607 2.81372C12.1464 2.25583 12.1464 1.35131 11.5607 0.793421C10.9749 0.235529 10.0251 0.235529 9.43934 0.793421L0.439342 9.36485C-0.146445 9.92274 -0.146445 10.8273 0.439341 11.3852L9.43934 19.9566C10.0251 20.5145 10.9749 20.5145 11.5607 19.9566C12.1464 19.3987 12.1464 18.4942 11.5607 17.9363L3.62132 10.375L11.5607 2.81372Z",
		fill: "white"
	})]
});
const ForwardRef = forwardRef(SvgArrowLeft);
export { ForwardRef as ReactComponent };
